import type { Monitor } from './intervals'
import { describeInterval } from './intervals'

/** One line for a read-only row: `Every 5 min · https://example.com`, `Paused`, or `Off`. */
export function summariseUptime(monitor: Monitor | null): string {
  if (monitor === null) return 'Off — not watched'
  if (!monitor.enabled) return `Paused · ${monitor.url}`
  return `${describeInterval(monitor.interval_seconds)} · ${monitor.url}`
}
